<template>
  <div class="col-md-8">
    <h4>Vui lòng nhập Giftcode</h4>
      <b-form-group
          label="Voucher khuyến mãi"
          label-for="input-formatter"
          class="mb-0"
      >
        <b-form-input
            id="input-formatter"
            v-model="form.code"
            placeholder="Enter your Giftcode"
        ></b-form-input>
      </b-form-group>
    <br>
      <b-button @click="onSubmit()"  variant="primary">Submit</b-button>
      <b-button  @click="onReset()" variant="danger">Reset</b-button>
  </div>
</template>

<script>
export default {
  name: "VoucherForm",
  props: {
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      form: {
        code: ''
      },
    }
  },
  methods: {
    async applyVoucher() {
      try {
        const uri = this.route('fe.apply_voucher', {domain: this.website.domain});
        const response = await this.Request.post(uri, this.form);

        if (response.data.status === false) {
          await this.$swal.fire(
              'Có lỗi xảy ra!',
              response.data.message,
              'error'
          );

        } else {
          await this.$swal.fire(
              'Thành Công!',
              response.data.message,
              'success'
          );

          // location.reload();
        }
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal.fire(
            'Có lỗi xảy ra!',
            errorMessages[0],
            'error'
        );
      }
    },
    async onSubmit() {
      await this.$swal.fire({
        title: 'Xác nhận!',
        text: 'Bạn thực sự muốn sử dụng Giftcode này?',
        showCancelButton: true,
        confirmButtonText: `Dùng ngay`,
        cancelButtonText: `Huỷ`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.applyVoucher();
        }
      })
    },
    onReset() {
      this.form.code = ''
    }
  }
}
</script>
